import { render, staticRenderFns } from "./TessereDelTifoso.vue?vue&type=template&id=a3cb9d50&lang=pug"
import script from "./TessereDelTifoso.vue?vue&type=script&lang=ts"
export * from "./TessereDelTifoso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports